/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-UI
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 12/14/2016
 * Copyright All Rights Reserved
 */

import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import entitiesReducer from './entities/';
import tokenReducer from './tokenReducer';

const rootReducer = combineReducers({
  entities: entitiesReducer,
  token: tokenReducer,
  form: formReducer,
});

export default rootReducer;
